import Vue from 'vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

@Component({
    data() {
        return {
            emailAddress: '',
            immediateValidation: false
        };
    },
    components: {
        ValidationProvider
    },
    inheritAttrs: false
})
export default class Email extends Vue {
    @Ref() readonly provider!: InstanceType<typeof ValidationProvider>;

    @Prop()
    value: string;

    @Prop()
    label: string;

    @Prop()
    placeholder: string;

    @Prop({ default: 'emailAddress' })
    inputName: string;

    @Prop()
    validationMode: string;

    @Prop({ type: String, default: '#06A9BF' })
    checkColor: string;

    @Prop({ type: Object, default: () => ({ required: false }) })
    rules: any;

    get emailRules() {
        return { email: true, ...this.rules };
    }

    emailAddress: string;
    immediateValidation: boolean;

    created() {
        this.emailAddress = this.value;
    }

    get ariaLabel() {
        if (this.rules.required) {
            return this.label;
        }

        return `${this.label}: ${this.$t('common:optional')}`;
    }

    @Watch('emailAddress')
    change(value: string) {
        this.$emit('input', value);
    }

    @Watch('value', { immediate: true })
    onChangeValue(value: string) {
        if (value?.length > 0) {
            this.immediateValidation = true;
        }
    }
}
